<template>
  <main>
    <section v-if="isMultipleCheck" class="multiple-card__container">
      <div
        v-for="(item, index) in multipleOptions"
        :key="index"
        class="molecule-radio-select-data--container"
        :class="{
          'molecule-radio-select-data--active': item.isSelect,
          'read-only': !canUpdate,
        }"
        @click="selectMultipleRadio(item)"
      >
        <div class="molecule-radio-select-data--topic">
          {{ item.topic }}
        </div>
        <div class="molecule-radio-select-data--description">
          {{ item.description }}
        </div>
      </div>
    </section>

    <section v-if="!isMultipleCheck">
      <div
        class="molecule-radio-select-data--container"
        :class="{
          'molecule-radio-select-data--active': selectedRadio === radioOption,
          'read-only': !canUpdate,
        }"
        @click="selectRadio(radioOption)"
      >
        <div class="molecule-radio-select-data--topic">
          {{ radioOption.topic }}
        </div>
        <div class="molecule-radio-select-data--description">
          {{ radioOption.description }}
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "MoleculeRadioSelectData",
  props: {
    radioOption: {
      type: Object,
      required: false,
      default: () => {}
    },
    selectedRadio: {
      type: [Object, null],
      required: false,
      default: () => {}
    },
    isMultipleCheck: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Array,
      required: false,
      default: () => []
    },
    canUpdate: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ["selected"],
  computed:{
    multipleOptions: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
  methods: {
    selectRadio(option) {
      this.canUpdate && this.$emit("selected", option)
    },
    selectMultipleRadio(item){
      this.canUpdate && (item.isSelect = !item.isSelect)
    }
  },
}
</script>

<style lang="scss" scoped>

.multiple-card__container {
  display: block;
}

.read-only {
  &:hover {
    pointer-events: none; 
  }
}

.molecule-radio-select-data--container {
  display: flex;
  align-items: center;
  background-color: #fbfbfc;
  min-height: 100%;
  width: 100%;
  border: 1px solid #ecedee;
  border-radius: 6px;
  padding: 13px 16px;
  transition: color 0.25s linear, background-color 0.25s linear, border 0.1s linear;
  &:hover {
    cursor: pointer;
  }
}

.molecule-radio-select-data--topic {
  font-weight: 600;
}

.molecule-radio-select-data--description {
  margin-top: 8px;
}

.molecule-radio-select-data--active {
  color: #7367f0;
  background-color: #f7f6fe;
  border: 1px solid #7367f0;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .molecule-radio-select-data--container {
    display: flex;
    align-items: center;
    margin-right: 20px;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .multiple-card__container {
    display: flex;
  }
  .molecule-radio-select-data--container {
    width: 180px;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .molecule-radio-select-data--container:not(.molecule-radio-select-data--active):not(.read-only) {
    &:hover {
      cursor: pointer;
      color: #7367f0;
      background-color: #f7f6fe;
      border: 1px solid #f7f6fe;
    }
  }
}

// Extra large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>

<!-- HOW TO USE THIS COMPONENT

for radio (Single Select) use 

      <molecule-radio-select-data
          v-for="(option, index) in radioSelectOptions"
          :key="index"
          :radioOption="option"
          :selectedRadio="selectedRadio"
          @selected="setSelectedOption"
        >
      </molecule-radio-select-data>

    setSelectedOption(option) {
      this.selectedRadio = option
    },


for checkbox (Multiple Select) use

    <molecule-radio-select-data
        :isMultipleCheck="true"
        v-model="radioSelectOptions"
      >
    </molecule-radio-select-data>
--!>
